
import FormInput2 from '@/components/forms/FormInput2.vue'
import NamedMembers from '@/components/membership/NamedMembers.vue'
import { randomIdentifier } from '@/helpers/StringHelpers'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'NamedMembersStory',
  components: { NamedMembers, FormInput2 },
})
export default class extends Vue {
  key: string = randomIdentifier()

  value = []
  name = 'Additional member'

  // Form inputs force controls to string values.
  required = '2'
  optional = '3'

  @Watch('required')
  @Watch('optional')
  generateKey() {
    this.key = randomIdentifier()
  }
}
